const JapanSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111668)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9998 28.6959C24.8023 28.6959 28.6954 24.8028 28.6954 20.0003C28.6954 15.1979 24.8023 11.3047 19.9998 11.3047C15.1974 11.3047 11.3042 15.1979 11.3042 20.0003C11.3042 24.8028 15.1974 28.6959 19.9998 28.6959Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111668">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default JapanSvg;
